import { publishStreamRequest, unpublishStreamRequest, publishStreamIceCandidate, publishStreamConnectionStateChange, } from "./actions";
import { ConferenceEventType } from "../model";
import { conferenceEvent, conferenceHoldEvent } from "../actions";
/**
 * Tests if request should be handled by saga
 * @param tasks - Object's keys are stream IDs
 */
export function unpublishStreamRequestPattern(tasks) {
    return (action) => action.type === unpublishStreamRequest.toString() &&
        action.payload.streamId in tasks;
}
/**
 * Tests if ice state change of rtc peer connection should concern this saga
 * @param tasks
 */
export function publishStreamConnectionStateChangePattern(tasks) {
    return (action) => action.type === publishStreamConnectionStateChange.toString() &&
        action.payload.streamId in tasks;
}
export function publishStreamRequestPattern(conferenceId) {
    return (action) => action.type === publishStreamRequest.toString() &&
        action.payload.conferenceId === conferenceId;
}
export function publishStreamIceCandidatePattern(streamId) {
    return (action) => action.type === publishStreamIceCandidate.toString() &&
        action.payload.streamId === streamId;
}
export function endpointJoinedPattern(conferenceId) {
    return (action) => action.type === conferenceEvent.toString() &&
        action.payload.type === ConferenceEventType.CONFERENCE_JOINED &&
        action.payload.conferenceId === conferenceId;
}
export function conferenceHoldPattern(conferenceId) {
    return (action) => action.type === conferenceHoldEvent.toString() &&
        action.payload.id === conferenceId;
}
